﻿/**
 * @module anddone-js
 * JavaScript SDK for AndDone Fragments
 */

import { AndDone } from './AndDone';
import type { InitConfig } from '@anddone/ajs-util';

/**
 * Initialize the AndDone SDK
 * @param config - Configuration including paymentIntentId, appKey
 * @returns AndDone instance with fragments, events, and internal orchestrator
 */
export function init(config: InitConfig): AndDone {
  return new AndDone(config);
}

// Export types for TypeScript users.
// Add to this list as we discover more types that should be exposed.
export type { InitConfig } from '@anddone/ajs-util';
